const binding = { modules: {}, dataActions: {} };

    (binding.modules['nss-product-feature-grid'] = {
        c: () => require('partner/modules/nss-product-feature-grid/nss-product-feature-grid.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'nss-product-feature-grid',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/nss-product-feature-grid'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|nss-product-feature-grid|nss-product-feature-grid'] = {
                c: () => require('partner/modules/nss-product-feature-grid/nss-product-feature-grid.view.tsx'),
                cn: '__local__-__local__-nss-product-feature-grid'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };